/**
 * Get the next datetime in the array, or estimate based on interval.
 * Used to extend step graphs to show the final bar.
 *
 * @param datetimes - Array of Date objects representing time points
 * @param currentDatetime - The current datetime to find the next for
 * @returns The next datetime in the array, or an estimated datetime based on interval
 */
export function getNextDatetime(datetimes: Date[], currentDatetime: Date): Date {
  const currentIndex = datetimes.findIndex((d) => d.getTime() === currentDatetime.getTime())

  if (currentIndex >= 0 && currentIndex < datetimes.length - 1) {
    return datetimes[currentIndex + 1]
  }

  // For the last point, estimate based on the interval from previous points
  if (datetimes.length >= 2) {
    const interval = datetimes[1].getTime() - datetimes[0].getTime()
    return new Date(currentDatetime.getTime() + interval)
  }

  // Fallback: add 1 hour
  return new Date(currentDatetime.getTime() + 3600000)
}
